export default __webpack_public_path__ + "static/media/Answer-a-Question.6f429687.svg";